import {FETCH_CODE} from '../constants/code';

export function fetchCode(text) {
  return ({
    type: FETCH_CODE,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: `/transactions/codes/${text}`,
    }
  });
}
